import { DocCategoryFormData, DocCategoryListApiResponse, DocCategoryGetApiResponse } from "../context/DocumentCategoryContext/constants";
import { axiosInstance } from "../utils/axiosInstance";

const ENDPOINTS = {
	ADD: "/cms/add-doc-category",
	UPDATE: "/cms/update-doc-category",
	REMOVE: "/cms/remove-doc-category",
	LIST: "/cms/get-doc-categories",
	GET: "/cms/get-doc-category-details",
};

export class DocCategoryService {
	static async addDocCategory(docCategoryData: DocCategoryFormData) {
		const formData = new FormData();

		formData.append("categoryNo", docCategoryData.categoryNo?.toString() ?? "");
		formData.append("name", docCategoryData.name);

		docCategoryData.documents?.forEach((file) => {
			formData.append("documents", file);
		});

		return await axiosInstance.post(`${ ENDPOINTS.ADD }`, formData);
	}

	static async getDocCategoryList(): Promise<DocCategoryListApiResponse> {
		const response = await axiosInstance.get(ENDPOINTS.LIST);
		return response.data;	
	}

	static async getDocCategoryDetails(id: string): Promise<DocCategoryGetApiResponse> {
		const response = await axiosInstance.get(`${ENDPOINTS.GET}?categoryId=${id}`);
		return response.data;
	}

	static async updateDocCategory(docCategoryData: DocCategoryFormData) {
		const formData = new FormData();

		formData.append("categoryId", docCategoryData.categoryId?.toString() ?? "");
		formData.append("categoryNo", docCategoryData.categoryNo?.toString() ?? "");

		docCategoryData.documents?.forEach((file) => {
			formData.append("documents", file); 
		});

		return await axiosInstance.put(`${ENDPOINTS.UPDATE}`, formData);
	}

	static async removeDocCategory(id: string) {
		return await axiosInstance.delete(`${ENDPOINTS.REMOVE}?categoryId=${id}`);
	}
}